module.exports = __webpack_public_path__ + "img/product-1-phone.6ed68304.png";